// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3mia6","label":"Section_label__2-HhL","contentWrap":"Section_contentWrap__15bua","footer":"Section_footer__2P1JS","footerInner":"Section_footerInner__VI7u5"};